import { AnchorLink } from 'components/anchorLink';
import { ItemWithTranslation } from 'types/swagger';
import { ScommesseTableDateTime } from 'components/scommesseTable/scommesseTableDateTime';
import { ScommesseTableShowMore } from 'components/scommesseTable/scommesseTableShowMore';
import { VirtualAvvenimentoRow } from '../virtualAvvenimentoRow/VirtualAvvenimentoRow';
import { VirtualCompetitors } from '../virtualCompetitors';
import { format } from 'date-fns';
import { selectElapsedTime } from 'lib/selectors';
import { setIsStarted } from 'features/virtual/virtualSlice';
import styles from './VirtualTableRow.module.scss';
import { useAmbienteContext } from 'context/Ambiente';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type VirtualTableRowProps = ItemWithTranslation<{
  descrizione?: string;
  firstCompetitor?: string;
  secondCompetitor?: string;
  firstAvvenimentoDescription?: string;
}> & {
  slug: string;
  dataOra?: string;
  isMobile?: boolean;
  isLeague?: boolean;
  children?: React.ReactNode;
  className?: string;
  hasHeader?: boolean; // TODO CHECK IF REMOVE
  hasShowMore?: boolean;
  viewAllItemsNumber?: number;
};
export const VirtualTableRow = ({
  slug,
  descrizione,
  firstCompetitor,
  secondCompetitor,
  className,
  children,
  dataOra,
  hasShowMore,
  isLeague,
  firstAvvenimentoDescription,
  viewAllItemsNumber,
}: VirtualTableRowProps) => {
  const { pathScommessa } = useAmbienteContext();
  // pathScommessa is like 'virtual', in this way it's possibile acced to state dynamically
  // selectElapsedTime is selector used in other component like ippica
  const { elapsedTime, minutes, seconds } = useTypedSelector((state) =>
    selectElapsedTime(state[`${pathScommessa[0]}`]?.currentTime, dataOra!)
  );

  const dispatch = useDispatch();

  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (elapsedTime! < 0) {
      dispatch(setIsStarted(true));
    }
  }, [elapsedTime, dispatch]);

  return (
    <div
      className={`${isMobile ? styles.vertical : ''} ${styles.container} ${className ? className : ''} ${
        isLeague ? styles.containerLeague : ''
      }`}
      suppressHydrationWarning
    >
      <VirtualAvvenimentoRow className={`${styles.avvenimento}`}>
        {dataOra && (
          <ScommesseTableDateTime
            ora={dataOra ? format(new Date(dataOra), 'kk:mm') : ''}
            data={dataOra ? format(new Date(dataOra), 'dd/MM') : ''}
            time={{ elapsedTime, minutes, seconds }}
            className={styles.dateTime}
          />
        )}
        <VirtualCompetitors
          firstCompetitor={firstCompetitor}
          secondCompetitor={secondCompetitor}
          description={descrizione}
          slug={`/${slug}`}
          className={styles.competitors}
          firstAvvenimentoDescription={firstAvvenimentoDescription}
        />
      </VirtualAvvenimentoRow>
      <div className={`${styles.column} ${styles.lineTop}`} suppressHydrationWarning>
        {children && children}
        {hasShowMore && (
          <AnchorLink href={`/${slug}`}>
            <ScommesseTableShowMore className={`${styles.showMore}`} results={viewAllItemsNumber} />
          </AnchorLink>
        )}
      </div>
    </div>
  );
};
